(function (window) {
  "use strict";
  const VDB = window.VDB = window.VDB || {};
  const bus = new EventTarget();
  VDB.eventNames = Object.freeze({
    READY:"vdb:ready",
    VEHICLE_SELECTED:"vdb:vehicle-selected",
    VEHICLE_CHANGED:"vdb:vehicle-changed",
    VEHICLE_CLEARED:"vdb:vehicle-cleared",
    DRAWER_OPEN:"vdb:drawer-open",
    DRAWER_CLOSE:"vdb:drawer-close",
    ERROR:"vdb:error"
  });
  VDB.events = {
    on(name, fn, options) {
      bus.addEventListener(name, fn, options);
      return () => bus.removeEventListener(name, fn, options);
    },
    off(name, fn, options) { bus.removeEventListener(name, fn, options); },
    emit(name, detail={}) {
      const event = new CustomEvent(name,{detail});
      bus.dispatchEvent(event);
      document.dispatchEvent(new CustomEvent(name,{detail}));
      return event;
    }
  };
})(window);
